// extracted by mini-css-extract-plugin
module.exports = {"modal-title":"CopyLeafNode_modal-title__NOpcL","copyLeafNode":"CopyLeafNode_copyLeafNode__i2c6_","copyLeafNodeTitle":"CopyLeafNode_copyLeafNodeTitle__0LZB1"};